import { Numeric } from "@salaxy/core";
/**
 * Formats value as euro price
 * @param value Numeric value to format
 * @param options Options for nummChar
 * @returns Value formatted as euro price
 */
export function hbsHelperC(value: number, options: any): string {
  const params = options && options.hash ? options.hash : options;
  return (value || value === 0) ? Numeric.formatPrice(value) : ((params && params.nullChar) ? params.nullChar : "-");
}